import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick, inject } from 'vue';
import util from '@/common/util';
import Latlng from '../js/latlng';
import { useMarkerClass } from './useMarkerClass';
import useMapUtil from '../js/useMapUtil';

export default function useMarker({ props, emit, parentDom, pop, popinter, markerRef, markerClassName = '', showFn, hiddenFn }) {
 
    let initMapMarker = null;
    let getCenter = null;
    let mapUtil = useMapUtil();

    const popStyle = ref({});
    const pointerStyle = ref({});
    const popBottom = ref(false);
    const showMarkerPop = ref(false);

    const onceRenderMarkerPop = () => {
        showMarkerPop.value = true;
    }
	
    // 注入applyMap
    const applyMap = inject('applyMap', () => {});
    
    // 计算属性
    const lat = computed(() => Latlng.getLatitude(props.data));
    const lng = computed(() => Latlng.getLongitude(props.data));
    const fmLatlng = computed(() => Latlng.format(props.data));
    const showPlus = computed(() => props.data?.items?.length > 1);
   
    
    // 监听active属性
    watch(() => props.active, (value) => {
        const parentEl = markerRef.value && markerRef.value.parentNode;
        if (parentEl && parentEl.classList.contains('marker-dom')) {
            parentEl.classList[value === fmLatlng.value ? 'add' : 'remove']('active');
        }
        if (value === fmLatlng.value) {
            nextTick(() => {
                onActive();
            });
        }
    });
    
    // 方法
    const onActive = () => {
        onceRenderMarkerPop();
        applyMap(([map, maps, siteMap]) => {
            if (!lat.value || !lng.value) {
                return; 
            }
            const newPopStyle = {};
            const newPointerStyle = {};
            const $pop = pop.value;
            const $pointer = popinter.value;
            const $markerRef = markerRef.value;
            const mapBounds = mapUtil.getBounds(map);
            if (!mapUtil.pointInbound(+lng.value, +lat.value, mapBounds)) {
                newPopStyle.left = '';
                newPointerStyle.left = '';
                map.setCenter({
                    lat: +lat.value,
                    lng: +lng.value
                });
                popStyle.value = newPopStyle;
                pointerStyle.value = newPointerStyle;
                return;
            }
            const mapWidth = (siteMap.$el && siteMap.$el.offsetWidth) || 0;
            const mapHeight =
                (siteMap.$el && siteMap.$el.offsetHeight) || 0;
            const xRatio = (mapBounds[1] - mapBounds[0]) / mapWidth;
            const yRatio = (mapBounds[3] - mapBounds[2]) / mapHeight;
            const pos = {
                top: -Math.round((+lat.value - mapBounds[3]) / yRatio),
                left: Math.round((+lng.value - mapBounds[0]) / xRatio),
                bottom: Math.round((+lat.value - mapBounds[2]) / yRatio),
                right: -Math.round((+lng.value - mapBounds[1]) / xRatio)
            };
            if ($pop?.offsetWidth > mapWidth - 30) {
                newPopStyle.whiteSpace = 'normal';
                newPopStyle.maxWidth = mapWidth - 30 + 'px';
                newPopStyle.width = 'max-content';
            }
            const width = ($pop?.offsetWidth / 2) || 0;
            const height = ($pop?.offsetHeight) || 0;
            const ctWidth = $markerRef.offsetWidth / 2;
            const ctHeight = $markerRef.offsetHeight / 2;
            const popHeight = height + ctHeight + 10;
            if (pos.top < popHeight) {
                if (pos.bottom < popHeight) {
                    const currentCenterPoint = getCenter(map);
                    let latOffset = 0;
                    if (pos.top > pos.bottom) {
                        latOffset = popHeight - pos.top;
                        popBottom.value = false;
                    } else {
                        latOffset = pos.bottom - popHeight;
                        popBottom.value = true;
                    }
                    map.setCenter({
                        lat: currentCenterPoint.lat + latOffset * yRatio,
                        lng: currentCenterPoint.lng
                    });
                } else {
                    popBottom.value = true;
                }
            } else {
                popBottom.value = false;
            }

            let left = '';
            if (width > pos.left) {
                left = ctWidth + width - pos.left + 10 + 'px';
            } else if (width > pos.right) {
                left = ctWidth + pos.right - width - 10 + 'px';
            }
            newPopStyle.left = left;

            if ($pointer) {
                if (left === '') {
                    newPointerStyle.left = '';
                } else {
                    const minLeft = $pointer.offsetWidth / 2 + 2;
                    newPointerStyle.left =
                        Math.min(
                            width * 2 - minLeft,
                            Math.max(minLeft, width + ctWidth - left)
                        ) + 'px';
                }
            }
            popStyle.value = newPopStyle;
            pointerStyle.value = newPointerStyle;
        });
    };
    
    const onMouseEnter = () => {
        // showFn?.();
        // onceRenderMarkerPop();
        // emit('update:active', fmLatlng.value);
        // const mouseEnterEvent = props.events?.mouseEnter;
        // mouseEnterEvent && mouseEnterEvent();
    };
    
    const onMouseLeave = () => {
        // hiddenFn?.();
        // emit('update:active', '');
        // const mouseLeaveEvent = props.events?.mouseLeave;
        // mouseLeaveEvent && mouseLeaveEvent();
    };
    
    const onClick = util.debounce(() => {
        showFn?.();
        onceRenderMarkerPop();
        emit('update:active', fmLatlng.value);
        const clickEvent = props.events?.click;
        clickEvent && clickEvent(props.data);
    }, 400);

    const outsideClick = function(e) {
        e.stopPropagation();
        hiddenFn?.();
        emit('update:active', '');
        // 卡片恢复事件，当没有恢复之前，再次移动地图，会导致失焦之后仍然移动
        // applyMap(([map, maps, siteMap]) => {
        //     markerClassIns.restoreToBeforeOffset({ siteMap, map });
        // });
    }
    
    const getData = (isOrigin) => {
        if (isOrigin) {
            return props.data.originData;
        } else {
            return props.data;
        }
    };
    
    let markerIns = null
    let markerClassIns = null
    // 生命周期钩子
    onMounted(async() => {
        if (lat.value && lng.value) {
            markerClassIns = useMarkerClass();
            initMapMarker = markerClassIns.initMapMarker;
            getCenter = markerClassIns.getCenter;
            markerIns = await initMapMarker({
                applyMap,
                marker: {
                    parentDom,
                    onMouseEnter,
                    onMouseLeave,
                    onClick,
                    getData
                },
                onready: () => {
                    emit('markerReady');
                },
                lat,
                lng,
                markerClassName
            });
        }
      
        const $pop = pop.value;
        if ($pop) {
            const wheelFn = function(evt) {
                evt.stopPropagation();
            };
            $pop.addEventListener('mousewheel', wheelFn, {
                passive: false
            });
            $pop.addEventListener('DOMMouseScroll', wheelFn, false);
            $pop.addEventListener('wheel', wheelFn, false);
        }
    });
    
    onBeforeUnmount(() => {
        if (markerIns) {
            markerIns.destroy();
            markerIns = null;
        }
        initMapMarker = null;
        getCenter = null;
    });
    
    return {
        showMarkerPop,
        popStyle,
        pointerStyle,
        popBottom,
        lat,
        lng,
        fmLatlng,
        showPlus,
        onActive,
        onMouseEnter,
        onMouseLeave,
        onClick,
        outsideClick,
        getData
    };
}